import React from "react";
import { MdInsertComment } from "react-icons/md";
import AttachmentPopover from "./AttachmentPopover";

const InvestmentSection = ({
  title,
  maxLimit,
  investments = [],
  attachments,
  onFileSelect,
  onAddMoreAttachments,
  onRemoveAttachment,
  onOpenImage,
  openPopoverKey,
  setOpenPopoverKey,
  onCommentClick,
  keyPrefix = "",
  getIdParams,
}) => {
  if (!investments || investments.length === 0) return null;

  return (
    <div className="mb-2">
      <div className="flex w-full px-6 pt-6 pb-2">
        <div style={{ width: "28%" }}>
          <span className="text-[16px] font-semibold text-gray-900">
            {title}
          </span>
          {maxLimit && (
            <span className="text-gray-400 text-[13px] ml-2">
              (Max Limit : {maxLimit})
            </span>
          )}
        </div>
      </div>
      {investments.map((investment, index) => (
        <div key={index} className="flex w-full px-6 py-2">
          <div style={{ width: "28%" }} className="text-gray-800 text-[15px]">
            {investment.label}
          </div>
          <div style={{ width: "16%" }} className="flex items-center justify-end text-gray-900 text-[15px] font-medium">
            ₹{parseFloat(investment.amount).toLocaleString()}
          </div>
          <div style={{ width: "10%" }} className="flex items-center justify-center">
            <AttachmentPopover
              attachmentKey={`${keyPrefix}-${index}`}
              attachments={attachments}
              onFileSelect={() => onFileSelect(
                `${keyPrefix}-${index}`,
                getIdParams(investment),
                investment.document_count
              )}
              onAddMoreAttachments={onAddMoreAttachments}
              onRemoveAttachment={onRemoveAttachment}
              onOpenImage={onOpenImage}
              openPopoverKey={openPopoverKey}
              setOpenPopoverKey={setOpenPopoverKey}
              documentCount={investment.document_count}
            />
          </div>
          <div style={{ width: "10%" }} className="flex items-center justify-center">
            <MdInsertComment
              className="w-5 h-5 text-gray-400 cursor-pointer hover:text-blue-600 transition-colors"
              onClick={() => onCommentClick(
                `${keyPrefix}-${index}`,
                getIdParams(investment)
              )}
            />
            {investment.comment_count > 0 && (
              <span className="ml-1 text-xs text-gray-600">{investment.comment_count}</span>
            )}
          </div>
          <div
            style={{ width: "36%" }}
            className="flex items-center justify-end text-gray-900 text-[15px] font-medium"
          >
            ₹{parseFloat(investment.actual_amount || 0).toLocaleString()}
          </div>
        </div>
      ))}
      <div className="border-b border-gray-200" />
    </div>
  );
};

export default InvestmentSection;
